import { ReactNode, useEffect, useState } from 'react'

interface TooltipProps {
  content: string
  children: ReactNode
  className?: string
  position?: 'top' | 'bottom'
}

export function Tooltip({ content, children, className = '', position = 'top' }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [isVisible])

  const handleInteraction = (state: boolean) => {
    setIsVisible(state)
  }

  const positionClasses = position === 'top' 
    ? 'bottom-full mb-2' 
    : 'top-full mt-2'

  const arrowClasses = position === 'top'
    ? 'top-full -mt-[1px] border-t-slate-900'
    : 'bottom-full -mb-[1px] border-b-slate-900 border-t-transparent'

  return (
    <div 
      className={`relative inline-block ${className}`}
      onClick={() => {
        // Prevent click from bubbling up if it's just meant for the tooltip
        // e.stopPropagation() // Optional: might strictly block other interactions, testing without first
        handleInteraction(!isVisible)
      }}
    >
      {children}
      {isVisible && (
        <div className={`absolute left-1/2 -translate-x-1/2 px-3 py-2 bg-slate-900 text-white text-xs font-bold rounded-lg whitespace-nowrap z-50 animate-in fade-in zoom-in-95 duration-200 shadow-xl pointer-events-none font-nunito ${positionClasses}`}>
          {content}
          {/* Arrow */}
          <div className={`absolute left-1/2 -translate-x-1/2 border-4 border-transparent ${arrowClasses}`} />
        </div>
      )}
    </div>
  )
}
